import { makeStyles } from '@griffel/react';

const useClasses = makeStyles({
  root: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
});

export const useFluent9FontSmoothingClassName = (): string => useClasses().root;
